<template>
    <div class="w-full max-w-md">
        <div class="flex h-full w-full flex-col divide-y">
            <NotificationItem
                v-for="(notification, index) in notificationsStore.all"
                :key="index"
                :notification="notification"
                @notification-clicked="handleClick"
                @mark-read="markRead"
            />
        </div>
    </div>
</template>

<script setup>
import { useNotificationsStore } from '@store/notifications';
import { buildNotificationRoute } from '@utilities/notificationActions';

const notificationsStore = useNotificationsStore();
const router = useRouter();
const emit = defineEmits(['close']);

const handleClick = async (notification) => {
    // Build route from notification data
    const route = buildNotificationRoute(notification);

    // Mark as read optimistically (updates local state without refetching)
    if (!notification.read_at) {
        notificationsStore.markAsReadOptimistic(notification.id);
    }

    // Navigate to the route
    if (route) {
        try {
            await router.push(route);
        } catch (error) {
            console.error('Navigation failed:', error);
            // Still close the panel even if navigation fails
        }
    }

    // Close panel after navigation
    emit('close');
};

async function markRead(notification) {
    if (!notification.read_at) {
        await notificationsStore.read(notification.id);
    }
}
</script>
